// import "./new.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
// import { useState, useEffect } from "react";
// import { studentrecordInputs } from "../../formSource";
// import { serverUrl } from "../../temp";

// const StudentrecordNew = ({ title }) => {
//   const [file, setFile] = useState("");
//   const [inputValues, setInputValues] = useState({});
//   const [notification, setNotification] = useState("");
//   const [isNotificationVisible, setIsNotificationVisible] = useState(false);
//   const [soption, setSoption] = useState([]);
//   const [selectedStudent, setSelectedStudent] = useState([]);
//   let [token] = useState(localStorage.getItem("token"));
//   const center_id = localStorage.getItem("center_id");
//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const handleInputChange = (e) => {
//     console.log(e.target.name);
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//     console.log("inputValues", inputValues);
//   };

//   const handleStudentSelectChange = (selectedOption) => {
//     setSelectedStudent(selectedOption);
//     setInputValues({
//       ...inputValues,
//       student_id: selectedOption.value,
//     });
//   };
//   useEffect(() => {
//     student_name();
//   }, []); // Empty dependency array means it runs once when the component mounts

//   const student_name = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/student_ids/${center_id}`);
//       if (!response.ok) {
//         throw new Error("Failed to fetch data from the API");
//       }
//       const data = await response.json();
//       console.log(data.data.length);
//       const namelist = [];
//       for (let i = 0; i < data.data.length; i++) {
//         const name = data.data[i].name;
//         console.log(name);
//         const id = data.data[i].id; // Access the "name" property
//         namelist.push({ value: id, label: name });
//       }
//       console.log(namelist);
//       setSoption(namelist);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("student_id", inputValues.student_id);
//     formData.append("description", inputValues.description);
//     formData.append("date", inputValues.date);
//     formData.append("status", inputValues.status || 1);
//     formData.append("file", file); // Append the file to FormData

//     try {
//       // Send formData to the server using an HTTP request with multipart/form-data
//       const response = await fetch(`${serverUrl}/add_srecord`, {
//         method: "POST",
//         body: formData, // Use formData here with multipart/form-data
//       });

//       const data = await response.json();
//       console.log("Response from API", data);

//       // Store formData in local storage
//       localStorage.setItem("formData", JSON.stringify(formData));

//       // Reset the form
//       setFile(""); // Clear the file
//       setInputValues({});
//       showNotification("Student Record has been added successfully!");
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const showNotification = (message) => {
//     setNotification(message);
//     setIsNotificationVisible(true);

//     // Automatically hide the notification after a certain time (e.g., 3 seconds)
//     setTimeout(() => {
//       setIsNotificationVisible(false);
//       setNotification("");
//     }, 3000); // Adjust the time as needed
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="new">
//           <Sidebar />
//           <div className="newContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               <div className="left">
//                 <img src={file} alt="" />
//               </div>
//               <div className="right">
//                 <form onSubmit={handleSubmit}>
//                   <div className="formInput">
//                     <label htmlFor="file">
//                       Report Card:{" "}
//                       <DriveFolderUploadOutlinedIcon className="icon" />
//                     </label>
//                     <input
//                       type="file"
//                       id="file"
//                       onChange={(e) => setFile(e.target.files[0])}
//                       style={{ display: "none" }}
//                     />
//                   </div>
//                   {studentrecordInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "student_id" ? (
//                         <Select
//                           options={soption}
//                           name={input.fieldName}
//                           value={selectedStudent}
//                           onChange={handleStudentSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formSubmit">
//                     <button type="submit" style={{ float: "right" }}>
//                       Send
//                     </button>
//                   </div>
//                 </form>
//                 {isNotificationVisible && (
//                   <div className="notification">{notification}</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default StudentrecordNew;




import "./new.scss";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState, useEffect, useCallback } from "react";
import { studentrecordInputs } from "../../formSource";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const FilePreviewContainer = styled('div')({
  position: 'relative',
  width: '100%',
  height: 200,
  borderRadius: 12,
  border: '2px dashed #e0e0e0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#fafafa',
  marginBottom: 20,
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&.drag-active': {
    borderColor: '#7451f8',
    backgroundColor: 'rgba(116, 81, 248, 0.05)',
  },
});

const PreviewImage = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
});

const FileInfo = styled('div')({
  marginTop: 10,
  textAlign: 'center',
  '& .fileName': {
    fontWeight: 500,
    color: '#333',
    fontSize: 14,
    marginTop: 8,
    wordBreak: 'break-all',
    padding: '0 10px',
  },
  '& .fileSize': {
    color: '#757575',
    fontSize: 12,
  },
});

const RemoveButton = styled(Button)({
  position: 'absolute',
  top: 8,
  right: 8,
  minWidth: 30,
  height: 30,
  borderRadius: '50%',
  padding: 0,
});

const isImage = (file) => file && file.type.startsWith("image/");
const isPDF = (file) => file && file.type === "application/pdf";

const StudentrecordNew = ({ title }) => {
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [soption, setSoption] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const center_id = localStorage.getItem("center_id");
  const token = localStorage.getItem("token");

  const redirectToLogin = () => {
    toast.warning("Please login first to access this page", {
      autoClose: 2000,
      onClose: () => (window.location.href = "/"),
    });
  };

  const handleDrag = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const selectedFile = e.dataTransfer.files[0];
      processFile(selectedFile);
    }
  }, []);

  const processFile = (selectedFile) => {
    if (!selectedFile) return;

    // Validate file type and size (max 5MB)
    if (!isImage(selectedFile) && !isPDF(selectedFile)) {
      toast.error("Please upload an image (JPEG, PNG) or PDF file");
      return;
    }

    if (selectedFile.size > 5 * 1024 * 1024) {
      toast.error("File size exceeds 5MB limit");
      return;
    }

    setFile(selectedFile);

    if (isImage(selectedFile)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFilePreview(e.target.result);
      };
      reader.readAsDataURL(selectedFile);
    } else if (isPDF(selectedFile)) {
      setFilePreview("/images/pdf_icon.png");
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      processFile(e.target.files[0]);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFilePreview("");
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleStudentSelectChange = (selectedOption) => {
    setSelectedStudent(selectedOption);
    setInputValues({
      ...inputValues,
      student_id: selectedOption.value,
    });
  };

  useEffect(() => {
    student_name();
  }, []);

  const student_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/student_ids/${center_id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch students");
      }
      const data = await response.json();
      const namelist = data.data.map(item => ({
        value: item.id,
        label: item.name
      }));
      setSoption(namelist);
    } catch (error) {
      console.error("Error fetching students:", error);
      toast.error("Failed to load student data");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Please upload a report card file");
      return;
    }

    if (!selectedStudent) {
      toast.error("Please select a student");
      return;
    }

    const formData = new FormData();
    formData.append("center_id", center_id);
    formData.append("student_id", inputValues.student_id);
    formData.append("description", inputValues.description || "");
    formData.append("date", inputValues.date || "");
    formData.append("status", inputValues.status || 1);
    formData.append("file", file);

    const toastId = toast.loading("Adding student record...");

    try {
      const response = await fetch(`${serverUrl}/add_srecord`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        toast.update(toastId, {
          render: data.message || "Failed to add student record",
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });

        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        }
      } else {
        toast.update(toastId, {
          render: "Student record added successfully!",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        // Reset form
        setFile(null);
        setFilePreview("");
        setInputValues({});
        setSelectedStudent(null);

        setTimeout(() => {
          // Navigate back to student records page
        }, 1500);
      }
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: "Error occurred while adding student record",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />
      {!token && redirectToLogin()}
      {token && (
        <div className="new">
          <Sidebar />
          <div className="newContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    className="formTitle"
                  >
                    {title}
                  </Typography>
                  <form onSubmit={handleSubmit} className="responsiveForm">
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="formGridItem">
                        <FilePreviewContainer
                          className={dragActive ? "drag-active" : ""}
                          onDragEnter={handleDrag}
                          onDragOver={handleDrag}
                          onDragLeave={handleDrag}
                          onDrop={handleDrop}
                        >
                          {filePreview ? (
                            <>
                              {isPDF(file) ? (
                                <PreviewImage
                                  src="/images/pdf_icon.png"
                                  alt="Report Card PDF"
                                />
                              ) : (
                                <PreviewImage
                                  src={filePreview}
                                  alt="Report Card Preview"
                                />
                              )}
                              {file && (
                                <>
                                  <FileInfo>
                                    <div className="fileName">{file.name}</div>
                                    <div className="fileSize">
                                      {(file.size / 1024).toFixed(1)} KB
                                    </div>
                                  </FileInfo>
                                  <RemoveButton
                                    variant="contained"
                                    color="error"
                                    onClick={handleRemoveFile}
                                  >
                                    ×
                                  </RemoveButton>
                                </>
                              )}
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                p: 2,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{ fontSize: 48, color: dragActive ? '#7451f8' : '#bdbdbd', mb: 1, transition: 'color 0.3s' }}
                              />
                              <Typography variant="body1" color="textSecondary">
                                {dragActive ? "Drop your file here" : "Drag & drop report card or"}
                              </Typography>
                              <Button
                                component="label"
                                variant="outlined"
                                startIcon={<DriveFolderUploadOutlinedIcon />}
                                sx={{ mt: 2 }}
                              >
                                Browse Files
                                <VisuallyHiddenInput
                                  type="file"
                                  accept="image/*,.pdf"
                                  onChange={handleFileChange}
                                  required
                                />
                              </Button>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                sx={{ mt: 1 }}
                              >
                                (Supports JPG, PNG, PDF up to 5MB)
                              </Typography>
                            </Box>
                          )}
                        </FilePreviewContainer>
                      </Grid>

                      {studentrecordInputs.map((input) => (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={input.id}
                          className="formGridItem"
                        >
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "student_id" ? (
                              <Select
                                options={soption}
                                name={input.fieldName}
                                value={selectedStudent}
                                onChange={handleStudentSelectChange}
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': { borderColor: '#cbd5e0' }
                                  }),
                                }}
                                required
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 3,
                        mt: 4,
                        pb: 2,
                      }}
                    >
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => window.history.back()}
                        sx={{ minWidth: "120px", height: "42px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: "150px", height: "42px" }}
                        // disabled={!file || !selectedStudent}
                      >
                        Add Record
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default StudentrecordNew;